import { viewpointConstants } from "../constants"

const initialState = {
    viewpoints: [],
    resources: [],
    // snapshots taken in Archicad, kept for the whole session so a viewpoint still has a thumbnail
    // while the api has none; the store is memory only, so they are gone on the next plugin start
    localImages: [],
    snapshotId: '',
    snapshotFlag: false
};

export function viewpoint(state = initialState, action) {
    switch (action.type) {
        case viewpointConstants.VP_GETALL: {
            let newVPs = action.payload;
            const oldVPs = state.viewpoints.filter(v => !newVPs.some(vp => vp.id === v.id));
            return {
                ...state,
                viewpoints: oldVPs.concat(newVPs)
            };
        }
        case viewpointConstants.VP_CLEAR: {
            return {
                ...state,
                viewpoints: []
            };
        }
        case viewpointConstants.VP_ADD_RESOURCE: {
            let rc = action.payload;

            return {
                ...state,
                resources: state.resources.find(r => r.id === rc.id) ? state.resources : [...state.resources, rc]
            };
        }
        case viewpointConstants.VP_ADD_LOCAL_IMAGE: {
            const localImage = action.payload;
            if (!localImage.imageId || !localImage.img) {
                return state;
            }

            return {
                ...state,
                localImages: state.localImages.find(l => l.imageId === localImage.imageId)
                    ? state.localImages
                    : [...state.localImages, localImage]
            };
        }
        case viewpointConstants.VP_SET_SNAPSHOTID: {
            return {
                ...state,
                snapshotId: action.payload,
                snapshotFlag: true
            };
        }
        case viewpointConstants.VP_CLEAR_SNAPSHOT: {
            return {
                ...state,
                snapshotId: '',
                snapshotFlag: false
            };
        }
        case viewpointConstants.VP_DELETE: {
            const deletedVpIds = action.payload;
            const updateVps = state.viewpoints.map(v => {
                if (deletedVpIds.includes(v.id))
                    v.deleted = true;
                return v;
            })

            return {
                ...state,
                viewpoints: updateVps
            }
        }

        default:
            return state;
    }
}